import { useEffect, useRef } from 'react';
/**
 * Dismissal of a small non-modal popup (the appearance menus of Trace Admin and the account hub): on open, focus moves
 * to its checked radio (else its first control); Escape closes it and gives focus back to the trigger; a press
 * outside, or focus moving outside (Tab past its end), closes it where the person went.
 */
export function usePopupDismiss({ panel, trigger, onDismiss }) {
    // The latest callbacks without re-running the effect (the effect's focus move must happen once per opening).
    const latest = useRef({ trigger, onDismiss });
    latest.current = { trigger, onDismiss };
    useEffect(() => {
        const root = panel.current;
        // One selector list would match in document order (the first radio, checked or not), so two lookups.
        (root?.querySelector('input[type="radio"]:checked') ??
            root?.querySelector('input, button, a[href]'))?.focus();
        const outside = (target) => target instanceof Node &&
            !panel.current?.contains(target) &&
            !latest.current.trigger()?.contains(target);
        const onKey = (event) => {
            if (event.key !== 'Escape')
                return;
            event.preventDefault();
            latest.current.onDismiss(true);
            latest.current.trigger()?.focus();
        };
        const onPointer = (event) => {
            if (outside(event.target))
                latest.current.onDismiss(false);
        };
        const onFocus = (event) => {
            if (outside(event.target))
                latest.current.onDismiss(false);
        };
        document.addEventListener('keydown', onKey);
        document.addEventListener('pointerdown', onPointer, true);
        document.addEventListener('focusin', onFocus);
        return () => {
            document.removeEventListener('keydown', onKey);
            document.removeEventListener('pointerdown', onPointer, true);
            document.removeEventListener('focusin', onFocus);
        };
    }, [panel]);
}
//# sourceMappingURL=usePopupDismiss.js.map